module.exports = __webpack_public_path__ + "img/magento-setup-tuning_medium@2x.7896803d.jpg";